import GenerationSwitcher from './GenerationSwitcher'

export default GenerationSwitcher